import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-sm border px-2 py-0.5 text-[0.6875rem] font-semibold uppercase tracking-[0.1em] transition-colors',
  {
    variants: {
      variant: {
        neutral:
          'border-[var(--color-hairline-strong)] bg-[var(--color-paper-dim)] text-[var(--color-ink-muted)]',
        primary:
          'border-[var(--color-primary)] bg-[var(--color-primary-50)] text-[var(--color-primary)]',
        success:
          'border-[var(--color-moss)] bg-[var(--color-moss-50)] text-[var(--color-moss)]',
        warning:
          'border-[var(--color-ochre)] bg-[var(--color-ochre-50)] text-[color-mix(in_oklch,var(--color-ochre)_60%,var(--color-ink))]',
        danger:
          'border-[var(--color-danger)] bg-[var(--color-danger-50)] text-[var(--color-danger)]',
        accent:
          'border-[var(--color-accent)] bg-[var(--color-accent-50)] text-[var(--color-accent)]',
        // Financial state variants
        pagado:
          'border-[var(--color-state-pagado)] bg-[var(--color-moss-50)] text-[var(--color-state-pagado)]',
        vencido:
          'border-[var(--color-state-vencido)] bg-[var(--color-danger-50)] text-[var(--color-state-vencido)]',
        anulado:
          'border-[var(--color-hairline-strong)] bg-[var(--color-paper-dim)] text-[var(--color-state-anulado)] line-through',
        reembolsado:
          'border-[var(--color-state-reembolsado)] bg-[var(--color-accent-50)] text-[var(--color-state-reembolsado)]',
        proyectado:
          'border-[var(--color-hairline)] bg-[var(--color-accent-50)] text-[var(--color-ink-muted)]',
        pendiente:
          'border-[var(--color-state-pendiente)] bg-[var(--color-accent-50)] text-[var(--color-state-pendiente)]',
        // Asamblea state variants
        borrador:
          'border-[var(--color-hairline-strong)] bg-[var(--color-paper-dim)] text-[var(--color-ink-muted)]',
        convocada:
          'border-[var(--color-primary)] bg-[var(--color-primary-50)] text-[var(--color-primary)]',
        en_votacion:
          'border-[var(--color-accent)] bg-[var(--color-accent-50)] text-[var(--color-accent)]',
        cerrada:
          'border-[var(--color-state-pagado)] bg-[var(--color-moss-50)] text-[var(--color-state-pagado)]',
        sin_quorum:
          'border-[var(--color-state-vencido)] bg-[var(--color-danger-50)] text-[var(--color-state-vencido)]',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
